import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { Box, Button, Checkbox, FormControlLabel, IconButton, Tooltip } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import _ from 'lodash'
import React from 'react'
import { withAppContext } from '../context/AppContextProvider'

const styles = () => ({
    saveCard: {
        marginRight: 0,
    },
    saveCardInfo: {
        padding: 8,
    },
})

class CardConnectFrame extends React.Component {
    state = {
        token: null,
        expiry: null,
        last4: null,
        paymentSaveCard: this.props.paymentSaveCard,
    }

    componentDidMount() {
        window.addEventListener('message', this.handlePostMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handlePostMessage)
    }

    handlePaymentSaveChange = () => {
        const { paymentSaveCard } = this.state

        this.setState({
            paymentSaveCard: !paymentSaveCard,
        })
    }

    handlePostMessage = (event) => {
        if (!event.origin.includes('cardconnect.com')) {
            return
        }

        try {
            var payload = JSON.parse(event.data)
        } catch (err) {
            return // not JSON
        }

        if ('token' in payload && 'expiry' in payload) {
            const { token, expiry } = payload
            const last4 = token.substr(token.length - 4)

            if (token && expiry) {
                let expiryMonth = _.padStart(expiry.substr(4), 2, '0')
                let expiryYear = expiry.substr(2, 2)

                this.setState({
                    token,
                    expiry: `${expiryMonth}${expiryYear}`,
                    last4,
                })

                return
            }
        }

        this.setState({
            token: null,
            expiry: null,
            last4: null,
        })
    }

    handleValidate = () => {
        const { token, expiry, last4, paymentSaveCard } = this.state

        if (!token || !expiry) {
            this.props.showError('Invalid payment information')
        }

        this.props.onTokenize(token, expiry, last4, null, null, paymentSaveCard)
    }

    render() {
        const { classes, className, processorSettings, forceSaveCard, saveCardLabel } = this.props
        const { token, expiry, paymentSaveCard } = this.state

        return (
            <Box className={className}>
                <iframe src={processorSettings.iframe} frameBorder="0" scrolling="no"></iframe><br />
                <Tooltip disableInteractive arrow title="Cards are securely stored as encrypted tokens. Your actual card number is never saved.">
                    <FormControlLabel
                        className={classes.saveCard}
                        disabled={forceSaveCard}
                        control={
                            <Checkbox
                                color="primary"
                                checked={paymentSaveCard}
                                onClick={this.handlePaymentSaveChange}
                            />
                        }
                        label={saveCardLabel || 'Save card on file (secure)'}
                    />
                </Tooltip>
                <Tooltip disableInteractive arrow title="Cards are securely stored as encrypted tokens. Your actual card number is never saved." enterTouchDelay={0} leaveTouchDelay={10000}>
                    <IconButton className={classes.saveCardInfo} size="large">
                        <HelpOutlineIcon />
                    </IconButton>
                </Tooltip><br />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        // this button doesn't really do anything other than act as something for the user to tap
                        // which causes the blur event needed for the cardconnect iframe to actually generate the token
                        // so we need to wait for token to come back before actually checking it
                        setTimeout(() => {
                            this.handleValidate()
                        }, 750)
                    }}
                >
                    Validate Card Info
                </Button><br />
            </Box>
        )
    }
}

export default withAppContext(withStyles(styles, { withTheme: true })(CardConnectFrame))
